/** The number the portal shows for an item or claim row. Users know submissions by this
 *  legacy per-case form, so it replaces item and claim numbers in the UI only; every row of
 *  the same case shows the same number. */
export function caseDisplayNumber(caseId: number): string {
  return `MDC-${caseId}`;
}
